import script from "./DatePickerCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatePickerCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./DatePickerCalendar.vue?vue&type=style&index=0&id=2651c37e&lang=scss"

const __exports__ = script;

export default __exports__